import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { selectConfig, selectWork, selectWorks } from '../../Api/selectors';
import { fetchVehicle,fetchVehicleInvoiceAttachments, initiateNewOrder } from '../actions';
import { REQUEST_VEHICLE, REQUEST_VEHICLE_ADD_TO_OUTGOING_ORDER, REQUEST_VEHICLE_INVOICES_ATTACHMENTS } from '../constants';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Loader } from '../../../components/Loader';
import { SelectClientToOrder } from './AddToOrderModals/SelectClient/SelectClientToOrderModal';
import { OutgoingOrderModal } from './AddToOrderModals/OutgoingOrder/OutgoingOrderModal';
import { Modal, ModalControls } from '../../../components/Modal';
import { Input } from '../../../components/Form';
import { FormField } from '../../../components/FormFields';
import { generateIncomingBpmInvoice } from '../actions';
import { Permission } from '../../../components/Permission';
import { VEHICLE_ADD_TO_ORDER, VEHICLE_SET_INCOMING_REST_BPM } from '../../../components/Permission/constants';
import { Cell, List, Row } from '../../../components/List';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import { selectVehicle } from '../selectors';
import { fetchInvoice, getInvoiceTradeInVehicles } from '../../Invoices/actions';
import { REQUEST_INVOICE, REQUEST_INVOICE_TRADE_IN_VEHICLES } from '../../Invoices/constants';
import { selectInvoice } from '../../Invoices/selectors';
import styles from './VehicleAddToOrderCard.module.css';
import { selectVehicleInvoicesAttachments } from '../selectors';

const Container = styled.div`
  font-size: 14px;
  width: ${props => (props.wide ? '100%' : '')};

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const STATE = {
  showSelectClientModal: false,
  showOutgoingOrderModal: false,
  showIncomingBPMModal: false,
  restBpmAmount: null,
  financialBpmGross: null,
  tradein: [],
  step: 1,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleAddToOrderCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  handleNext = () => {
    this.setState(prevState => ({
      step: prevState.step + 1,
    }));
  };

  handlePrev = () => {
    this.setState(prevState => ({
      step: prevState.step - 1,
      showSelectClientModal: true,
      showOutgoingOrderModal: false,
    }));
  };

  componentDidMount() {
    this.props.init();
    if (this.props.copyFromInvoiceId) {
      this.props.fetch();
      if (!this.props.copyFromInvoice?.id) {
        this.props.fetchInvoice();
      }

      this.props.fetchInvoiceTradeIn(result => {
        if (result?.length) {
          this.setState({ tradein: result });
        }
      });
    }
  }

  onReset() {
    this.setState({ ...STATE });
  }

  onRestBPMChange = e => {
    const { value } = e.target;
    this.setState({ restBpmAmount: +value });
  };

  onFinancialBpmGrossChange = e => {
    const { value } = e.target;
    this.setState({ financialBpmGross: +value });
  };

  get vehicle() {
    return this.props.copyFromInvoiceId ? this.props.vehicleToCopyInvoice : this.props.vehicle;
  }

  submitBpm = () => {
    const input = {
      restBPMAmount: this.state.restBpmAmount,
      financialBpmGross: this.state.financialBpmGross,
    };
    this.props.generateIncomingBpm(this.vehicle?.id, input);
    this.setState({ showIncomingBPMModal: false, restBpmAmount: 0, financialBpmGross: 0 });
  };

  get submitBpmDisabled() {
    return !this.state.restBpmAmount && this.state.restBpmAmount !== 0;
    //||
    //(!this.state.financialBpmGross && this.state.financialBpmGross !== 0);
  }

  renderIncomingBpmModal = () => (
    <Modal onClose={this.onReset.bind(this)} title={this.lbl('vehicle.order.bpm_invoice_modal_title')}>
      <VBox>
        <FormField label={this.lbl('vehicle.order.rest_bpm_amount')}>
          <Input
            name="bpm"
            type="number"
            step="0.01"
            min="0"
            value={this.state.restBpmAmount}
            onChange={this.onRestBPMChange}
          />
        </FormField>
        <FormField label={this.lbl('vehicle.order.financial_bpm_gross')}>
          <Input
            name="bpm_gross"
            type="number"
            step="0.01"
            min="0"
            value={this.state.financialBpmGross}
            onChange={this.onFinancialBpmGrossChange}
          />
        </FormField>
      </VBox>
      <ModalControls>
        <Button small isPrimary onClick={this.onReset.bind(this)}>
          {this.lbl('cancel')}
        </Button>
        <Permission permission={VEHICLE_SET_INCOMING_REST_BPM}>
          <Button small isPrimary onClick={this.submitBpm} disabled={this.submitBpmDisabled}>
            {this.lbl('ok')}
          </Button>
        </Permission>
      </ModalControls>
    </Modal>
  );

  handleBPMClick = () => {
    if (!!this.vehicle?.incoming_bpm_invoice) {
      this.to(`/invoices/${this.vehicle?.incoming_bpm_invoice}`);
    } else {
      this.setState({ showIncomingBPMModal: true });
    }
  };

  renderIncomingRestBPMBtn() {
    const { vehicle } = this.props;
    return (
      !this.props?.serverConfig?.disableBPMInvoices && env.clientId !== AppClientId.HOOIKAMMER && (
        <Button
          disabled={vehicle.incoming_invoice_in_helga === '1'}
          onClick={this.handleBPMClick}
        >
          {vehicle?.incoming_bpm_invoice && env.clientId !== AppClientId.AUTOWIENTJES
            ? this.lbl('vehicle.order.open_incoming_bpm_invoice')
            : this.lbl('vehicle.order.set_incoming_bpm')}
        </Button>
      )
    );
  }
  onOpenModal() {
    this.setState({ showSelectClientModal: true });
    if (!this.props.vehicle.tax_type && 
        (env.clientId === AppClientId.INDEWAL || env.clientId === AppClientId.HARRY_NIJBOER || env.clientId === AppClientId.IDWLEASE || env.clientId === AppClientId.AUTOHUISSALLAND)) {
      alert("You need to fill in tax_type before you can proceed.");
    }
  }

  render() {
    const vehicle = this.vehicle;
    if (this.props.work || !vehicle?.id) return <Loader small="true" />;
    return (
      <Container wide={this.props.copyFromInvoiceId}>
        <Permission permission={VEHICLE_ADD_TO_ORDER}>
          <br />
          <Row>
            {' '}
            {this.props.copyFromInvoiceId ? (
              <HBox center>
                <Button
                  disabled={vehicle?.outgoing_invoice_in_helga === '1' || this.props.work}
                 style={{backgroundColor: '00BFAE'}}
                  onClick={() => this.onOpenModal()}
                >
                  {this.lbl('invoice.details.creditAndCopyBtn')}
                </Button>
              </HBox>
            ) : (
                <div className={styles.containerButton}>
                  <Button
                    className={styles.buttonOpenModal}
                disabled={vehicle?.outgoing_invoice_in_helga === '1' || this.props.work}
                primary={vehicle?.outgoing_invoice !== '1'}
                onClick={
                  vehicle?.outgoing_invoice
                    ? () => this.to(`/invoices/outgoing/${vehicle?.outgoing_invoice}`)
                    : () => this.onOpenModal()
                }
              >
                {vehicle?.outgoing_invoice
                  ? this.lbl('vehicle.order.open_outgoing__order')
                  : this.lbl('vehicle.order.add_to_order')}
              </Button>
</div>
            )}
          </Row>
        </Permission>
        {!this.props.copyFromInvoiceId && window.innerWidth > 768 && (
          <Row>
            <Permission permission={VEHICLE_SET_INCOMING_REST_BPM}>
              {!this.props?.serverConfig?.disableBPM && this.renderIncomingRestBPMBtn()}
            </Permission>
          </Row>
        )}
        {this.state.showSelectClientModal && (
          <SelectClientToOrder
            copyFromInvoice={this.props.copyFromInvoice}
            copyFromInvoiceId={this.props.copyFromInvoiceId}
            reset={this.onReset.bind(this)}
            vehicle={vehicle}
            onClose={() => this.setState({ showSelectClientModal: false })}
            onNextModal={() => this.setState({ showSelectClientModal: false, showOutgoingOrderModal: true })}
            step={this.state.step}
            handleNext={this.handleNext}
          />
        )}
        {this.state.showOutgoingOrderModal && this.state.step === 2 && (
          <OutgoingOrderModal
            copyFromInvoice={this.props.copyFromInvoice}
            tradeInToCopy={this.state.tradein}
            reset={this.onReset.bind(this)}
            vehicle={vehicle}
            onClose={() => this.setState({ showSelectClientModal: false, showOutgoingOrderModal: false })}
            step={this.state.step}
            handlePrev={this.handlePrev}
          />
        )}
        {this.state.showIncomingBPMModal && this.renderIncomingBpmModal()}
      </Container>
    );
  }
}

VehicleAddToOrderCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      REQUEST_VEHICLE_ADD_TO_OUTGOING_ORDER,
      REQUEST_VEHICLE,
      REQUEST_INVOICE_TRADE_IN_VEHICLES + ownProps.copyFromInvoiceId,
      REQUEST_INVOICE,
    ]),
    serverConfig: selectConfig(),
    vehicleToCopyInvoice: selectVehicle(ownProps.vehicleId),
    copyFromInvoice: selectInvoice(ownProps.copyFromInvoiceId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    init() {
      dispatch(initiateNewOrder());
    },
    fetch() {
      dispatch(fetchVehicle(ownProps.vehicleId));
    },
    fetchInvoice() {
      dispatch(fetchInvoice(ownProps.copyFromInvoiceId));
    },
    fetchInvoiceTradeIn(callback) {
      dispatch(getInvoiceTradeInVehicles(ownProps.copyFromInvoiceId, callback));
    },
    generateIncomingBpm(vehicleId, input) {
      dispatch(generateIncomingBpmInvoice(vehicleId, input));
    },
    fetchVehicleInvoiceAttachments() {
      dispatch(fetchVehicleInvoiceAttachments(ownProps.vehicle?.id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleAddToOrderCard = compose(withConnect, withRouter)(VehicleAddToOrderCardComp);
